<div [class]="value$ | async">

  {{ label$ | async }}

</div>
